import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 

import ResourceRow from "../components/ResourceRow"



class FormResources extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();

        this.addResource = this.addResource.bind(this);
        this.removeResource = this.removeResource.bind(this);
        this.updateResource = this.updateResource.bind(this);


    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
 

    setup(){

        let StateChange = {
            Resources: [], 

            renderState: null,

            FormData: {},

        }

        StateChange.onUpdate = this.props.onUpdate;
        if (getParam('Resources', this.props)){
            StateChange.Resources = getParam('Resources', this.props);
        }
        StateChange.FormData.Resources = StateChange.Resources;
        StateChange.renderState = 'loaded';
        this.setState(StateChange);

    }

    render(){

        switch (this.state.renderState){
            case "loaded":

                let seqNext = 1;

                if (this.state.FormData.Resources){
                    seqNext = this.state.FormData.Resources.length + 1;
                }
                return (
                    <div>
                        <PD.Heading level="2">Resources</PD.Heading>
                        <PD.Table type="list">
                            {this.state.FormData.Resources &&
                                this.state.FormData.Resources.map(
                                    (Resource, posResource) => 
                                    {
                                        let seq = posResource+1;
                                        return(
                                            this.FormResource('edit', seq, Resource)
                                        )
                                    }
                                )
                            }
                            {this.FormResource('new', seqNext)}
                        </PD.Table>
                    </div>
                );
            default:
                return null;
        };

    }

    FormResource(mode, seq, Resource = {}){
        return(
            <ResourceRow
                key={seq.toString()}
                mode={mode}
                Resource={Resource}
                seq={seq}

                onAdd={this.addResource}
                onRemove={this.removeResource}
                onUpdate={this.updateResource}

            />
        )
    }

    addResource(){
        let FormData = {...this.state.FormData};
        FormData.Resources = [...(FormData.Resources || []), {}];
        
        this.setState({"FormData": FormData});
        if (this.state.onUpdate){
            this.state.onUpdate(FormData.Resources);
        }
    }

    removeResource(seq){
        let FormData = {...this.state.FormData};
        FormData.Resources = [...(FormData.Resources || [])];
        FormData.Resources.splice(seq-1, 1);
        
        this.setState({"FormData": FormData});
        if (this.state.onUpdate){
            this.state.onUpdate(FormData.Resources);
        }

    }

    updateResource(seq, Resource){

        let FormData = {...this.state.FormData};
        FormData.Resources = [...(FormData.Resources || [])];
        FormData.Resources[seq-1] = Resource;

        this.setState({"FormData": FormData});
        if (this.state.onUpdate){
            this.state.onUpdate(FormData.Resources);
        }

    }
}



export default function FormResources_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <FormResources {...props} navigation={navigation} location={location} params={params} />;
  }
